import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { LayoutType } from '../../../constants/LayoutConstants';
import { VisibilityStore } from '../../../stores/VisibilityStore';
import { PopupMenu } from '../../../constants/Enums';
import { SelectBoxOption } from '../../../stores/SelectBoxStore';
import { CatalogActions } from '../../../actions/CatalogActions';
import { VisibilityActions } from '../../../actions/VisibilityActions';
import { PopupFlagPosition } from '../../../constants/PopupFlagPositions';
import { BasePopupMenu } from '../../popupmenu/BasePopupMenu';

import eaiws = egr.wcf.eaiws;

interface CatalogSelectBoxProps {
    catalogPath: Array<eaiws.catalog.CatalogItem>;
    catalog: eaiws.catalog.CatalogItem;
    rightSide: boolean;
    layoutType: LayoutType;
}

interface CatalogSelectBoxState {
    open: boolean;
}

export class CatalogSelectBox extends BaseComponent<CatalogSelectBoxProps, CatalogSelectBoxState> {
    public componentWillMount(): void {
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!this.props.catalog) {
            return null;
        }

        return (
            <BasePopupMenu
                defaultValue={null}
                flagPosition={PopupFlagPosition.TOPLEFT}
                open={this.state.open}
                toggleCallback={this.toggleSelect}
                className={'catalog-menu' + (this.props.rightSide ? ' on-right-side' : '')}
                options={this.getSelectOptions()}
                title={{label: t('Catalogs')}}
            >
                {this.state.open ? null : this.props.children}
            </BasePopupMenu>
        );
    }

    protected onChange = (): void => {
        this.setState({
            open: VisibilityStore.getState().popupMenu === PopupMenu.CATALOG
        });
    };

    protected getSelectOptions = (): Array<SelectBoxOption> => {
        const tResult: Array<SelectBoxOption> = [];
        for (let tCatalogId: number = 1; (tCatalogId) < this.props.catalogPath.length; tCatalogId++) {
            let label: string = this.props.catalogPath[tCatalogId - 1].label;
            if (!label) {
                label = this.props.catalogPath[tCatalogId - 1].name;
            }
            tResult.unshift({
                callback: () => { CatalogActions.enterPath(this.props.catalogPath.slice(0, tCatalogId)); },
                key: 'catalog_' + tCatalogId.toString(),
                name: label,
                className: 'folder-option'
            });
        }
        if (tResult.length) {
            tResult.push({
                key: 'separator',
                name: 'separator',
                className: 'no-icon separator-option'
            });
        }
        if (this.props.catalog != null) {
            tResult.push({
                callback: () => { CatalogActions.enterPath([]); },
                key: 'catalog_0',
                name: t('Catalog overview'),
                className: 'catalogs-option'
            });
        }
        return tResult;
    };

    protected toggleSelect = (pValue: boolean) => {
        if (!pValue) {
            VisibilityActions.setPopupMenu(PopupMenu.CATALOG);
        } else {
            VisibilityActions.hidePopupMenu(PopupMenu.CATALOG);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/catalog/CatalogSelectBox.tsx